import { DependencyItemObjectConverter } from './dependency.item.converter';
import { CatalogTreeCardObject } from '../../../models/catalog/catalog-tree-item-object.model';
import { Injectable } from '@angular/core';
import { Converter } from 'src/app/services/api/converter.interface';
import { isNullOrUndefined } from 'util';

@Injectable({
    providedIn: 'root'
})

export class CatalogTreeObjectConverter implements Converter<CatalogTreeCardObject> {

    constructor(private converter: DependencyItemObjectConverter) { }

    convert(input: any): CatalogTreeCardObject {

        if (isNullOrUndefined(input)) {
            return CatalogTreeCardObject.create();
        }

        const dependencies = this.converter.convert(input.dependencies);

        return new CatalogTreeCardObject(input.id, input.name, input.type, input.version, dependencies, this.getChildren(input.children));
    }

    public getChildren(input: any): Array<CatalogTreeCardObject> {
        if (isNullOrUndefined(input)) {
            return null;
        }
        const children = Array<CatalogTreeCardObject>();
        input.forEach(element => {
            const dependencies = this.converter.convert(element.dependencies);
            children.push(new CatalogTreeCardObject(element.id, element.name, element.type, element.version, dependencies, this.getChildren(element.children)));
        });

        return children;
    }
}
